module.exports = __webpack_public_path__ + "static/media/me2.cdb17174.jpg";